(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gf-app"] && !Shopify.designMode) return;
  try {
    
function initGFApps(root=document){root.querySelectorAll('.gf-app-plus').forEach(section=>{if(section.dataset.initialized)return;section.dataset.initialized='true';const tabs=[...section.querySelectorAll('[role="tab"]')],panels=[...section.querySelectorAll('[role="tabpanel"]')];function select(tab,focus){tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1});panels.forEach(p=>{p.hidden=p.id!==tab.getAttribute('aria-controls')});if(focus)tab.focus();tab.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'})}tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(tab,false));tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i-1+tabs.length)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();select(tabs[n],true)})})})}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initGFApps());else initGFApps();document.addEventListener('shopify:section:load',e=>initGFApps(e.target.parentElement||document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
